import React, { useState, useEffect } from 'react';
import LoveLetter from './LoveLetter';

const ProtectedLoveLetter: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated (stored in sessionStorage)
    const authStatus = sessionStorage.getItem('loveLetterAuth');
    if (authStatus === 'authenticated') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (username.toLowerCase() === 'safa' && password === 'tahmid') {
      setIsAuthenticated(true);
      sessionStorage.setItem('loveLetterAuth', 'authenticated');
    } else {
      setError('Invalid username or password');
      setPassword('');
    }
  };

  if (isLoading) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        }}
      >
        <div className="text-2xl">💌</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <LoveLetter />;
  }

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        fontFamily: 'Georgia, serif'
      }}
    >
      <div 
        className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 md:p-10"
        style={{
          background: 'linear-gradient(to bottom, #fffef7 0%, #fff9e6 100%)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          border: '1px solid rgba(220, 200, 180, 0.3)'
        }}
      >
        {/* Decorative header */}
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">🔒</div>
          <h1 
            className="text-2xl font-bold mb-2"
            style={{ color: '#8b6f47' }}
          >
            December 4, 2025
          </h1>
          <p 
            className="text-sm italic"
            style={{ color: '#8b6f47' }}
          >
            Enter Username and Password
          </p>
        </div>

        {/* Login form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label 
              htmlFor="username"
              className="block text-sm font-medium mb-2"
              style={{ color: '#3d3d3d' }}
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 transition-all"
              style={{
                borderColor: 'rgba(139, 111, 71, 0.3)',
                backgroundColor: '#fffef7'
              }}
              onFocus={(e) => e.target.style.borderColor = '#8b6f47'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 111, 71, 0.3)'}
              placeholder="Enter username"
              required
              autoFocus
            />
          </div>

          <div>
            <label 
              htmlFor="password"
              className="block text-sm font-medium mb-2"
              style={{ color: '#3d3d3d' }}
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 transition-all"
              style={{
                borderColor: 'rgba(139, 111, 71, 0.3)',
                backgroundColor: '#fffef7'
              }}
              onFocus={(e) => e.target.style.borderColor = '#8b6f47'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 111, 71, 0.3)'}
              placeholder="Enter password"
              required
            />
          </div>

          {error && (
            <div 
              className="text-sm text-red-600 text-center py-2 px-4 rounded"
              style={{ backgroundColor: 'rgba(220, 53, 69, 0.1)' }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full py-3 rounded-lg font-medium text-white transition-all hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{
              backgroundColor: '#8b6f47'
            }}
          >
            Unlock 💌
          </button>
        </form>

        {/* Decorative footer */}
        <div className="mt-8 text-center text-xl opacity-30">
          ✨
        </div>
      </div>
    </div>
  );
};

export default ProtectedLoveLetter;

